<template>
    <v-app-bar app :color="kingsGreen" dark>
        <v-app-bar-nav-icon @click="setDrawer()"></v-app-bar-nav-icon>
        <v-toolbar-title>Residence Application Portal</v-toolbar-title>
        <v-spacer />
        <v-toolbar-title class="mr-2 subtitle-2">{{ getUserName }}</v-toolbar-title>
        <v-avatar v-if="getUserAvatar()" size="36px">
            <img class="avatar__fluid" :src="avatar" alt="avatar">
        </v-avatar>
        <v-avatar v-else :color="kingsGold" size="36px">
            {{ getUserInitials }}
        </v-avatar>
    </v-app-bar>
</template>

<script>
import auth from '../../js/auth';

export default {
    name: 'student-toolbar',
    props: {
        drawer: {
            required: false,
            type: Boolean
        }
    },
    data() {
        return {
            avatar: '',
        }
    },
    methods: {
        getUserAvatar() {
            const user = auth.getUser();

            if (user && user.avatar) {
                this.avatar = user.avatar;
                return true;
            }

            return false;
        },
        setDrawer() {
            this.$emit('setDrawer');
        }
    },
    computed: {
        getUserInitials() {
            const user = auth.getUser().commonName.split(" ");

            if (user) {
                return `${user[0].charAt(0)}${user[1].charAt(0)}`;
            }

            return 'N/A';
        },
        getUserName() {
            return auth.getUser().commonName;
        },
        kingsGold() {
            return '#d7ae28';
        },
        kingsGreen() {
            return '#004236';
        }
    }
}
</script>